import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.section`
  width: 60%;
  min-width: 690px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 0 0 auto;

  p {
    width: 90px;
    height: 28px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00b5a6;
    border: solid 1px #9ae1d7;
    border-radius: 3px;
    box-sizing: border-box;
    margin: 0 10px 0 0;

    &:before {
      content: '';
      position: absolute;
      right: -14px;
      border: 6px solid transparent;
      border-left: 10px solid #fff;
      z-index: 2;
    }

    &:after {
      content: '';
      position: absolute;
      right: -15px;
      border: 5px solid transparent;
      border-left: 9px solid #9ae1d7;
      z-index: 1;
    }

    span {
      display: block;
      margin: 0;
      padding: 0;
    }
  }

  a {
    display: block;
    margin: 0 10px 0 20px;
  }

  ${BreakPoints.xxLarge} {
    width: 100vw;
    min-width: unset;
    margin: 0;
    padding: 2px 10px 0;
    justify-content: flex-start;
  }
`

/**
 * コラムサイトヘッダー製品情報コンポーネント
 * @constructor
 */
const ColumnHeadNav = () => {
  const routePram = useRouteParam('/feature/')
  const routePram2 = useRouteParam('/benefit/')
  const routePram3 = useRouteParam('/function/')
  const routePram4 = useRouteParam('/plan-list/')

  return (
    <Wrapper>
      <p>製品情報</p>
      <a href={routePram} target="_blank" rel="noreferrer">
        特徴
      </a>
      <a href={routePram2} target="_blank" rel="noreferrer">
        導入メリット
      </a>
      <a href={routePram3} target="_blank" rel="noreferrer">
        機能一覧
      </a>
      <a href={routePram4} target="_blank" rel="noreferrer">
        料金プラン
      </a>
    </Wrapper>
  )
}

export default ColumnHeadNav
